type ColloLike = {
    barcode?: string | null
    status?: string
    pickupAddressIndex?: number
    deliveryAddressIndex?: number
}

type OrderLike = {
    colli?: ColloLike[]
    addresses?: {type?: string}[]
}

/**
 * The address of the scanned order where this collo is currently expected. A collo that still has to
 * be collected belongs at its pickup address, even when its delivery address is already known.
 */
export function getScannedAddressIndex(order: OrderLike | null | undefined, barcode: string) {
    const collo = order?.colli?.find((collo) => collo.barcode === barcode)

    if (!collo) {
        return undefined
    }

    if (typeof collo.pickupAddressIndex === 'number' && ['pickup', 'outforpickup'].includes(collo.status || '')) {
        return collo.pickupAddressIndex
    }

    return typeof collo.deliveryAddressIndex === 'number' ? collo.deliveryAddressIndex : collo.pickupAddressIndex
}

export function getScannedAddressType(order: OrderLike | null | undefined, barcode: string): 'pickup' | 'delivery' {
    const index = getScannedAddressIndex(order, barcode)
    const address = typeof index === 'number' ? order?.addresses?.[index] : null

    return address?.type === 'pickup' ? 'pickup' : 'delivery'
}
